import * as React from 'react';
import { Input, Select, Checkbox } from 'antd';
import { FormItem } from '../../../../components/Form';
import PriceInput from '../../../../components/Others/PriceInput';
import { getPaymentGatewayTypes } from '../../../../helpers/PaymentGateways/paymentGateways';
import { imageUrl } from '../../../../config/config';
import UploadInput from '../../../../components/Form/components/UploadInput';

export interface IGeneralSettingsColProps {
  paymentMethod: GQL.IPaymentMethod;
  currentLanguage: string;
  onChange: Function;
}

export default class GeneralSettingsCol extends React.Component<IGeneralSettingsColProps> {

  public render() {
    const { paymentMethod, currentLanguage } = this.props;

    return (
      <div>
        <FormItem label={'Title'} required={true}>
          <Input
            name={'title'}
            autoFocus={true}
            placeholder="Internal title. For example &quot;Credit Card&quot;"
            addonBefore={'Internal'}
            defaultValue={paymentMethod.title || ''}
            required={true}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Name'} required={true}>
          <Input
            key={currentLanguage}
            name={'name'}
            addonBefore={currentLanguage}
            placeholder="Method's name in the eshop"
            defaultValue={(paymentMethod.name || {})[currentLanguage]}
            required={true}
            onChange={e => this.props.onChange(e, currentLanguage)}
          />
        </FormItem>
        <FormItem label={'Description'}>
          <Input.TextArea
            key={currentLanguage}
            name={'description'}
            placeholder="Method's description in the eshop"
            defaultValue={(paymentMethod.description || {})[currentLanguage]}
            onChange={e => this.props.onChange(e, currentLanguage)}
          />
        </FormItem>
        <FormItem label={'Price (vat excl.)'}>
          <PriceInput
            name={'prices'}
            mode={'priceWithout'}
            prices={paymentMethod.prices || []}
            onChange={this.props.onChange}
          />
        </FormItem>
        <FormItem label={'Online Payment Gateway'}>
          <Select
            defaultValue={paymentMethod.gateway || ''}
            style={{ width: '100%' }}
            placeholder="Select a supported payment gateway"
            allowClear={true}
            onChange={(value: string) => this.props.onChange({ target: { name: 'gateway', value } })}
          >
            {getPaymentGatewayTypes().map((gp: any) => (
              <Select.Option key={gp.value} value={gp.value}>{gp.caption}</Select.Option>
            ))}
          </Select>
        </FormItem>

        <FormItem label={'Priority'}>
          <Input
            name={'priority'}
            type={'number'}
            defaultValue={paymentMethod.priority
              ? paymentMethod.priority.toString()
              : undefined}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>

        <FormItem label={'Logo'}>
          <UploadInput
            accept={'image/*'}
            action={`${imageUrl}/images`}
            listType="picture-card"
            value={paymentMethod.image || null}
            onChange={(value: any) => this.props.onChange({ target: { name: 'image', value } })}
          />
        </FormItem>
        <FormItem>
          <Checkbox
            name={'active'}
            checked={paymentMethod.active !== null && paymentMethod.active !== undefined ? paymentMethod.active : true}
            onChange={e => this.props.onChange(e)}
          >
            Active
          </Checkbox>
        </FormItem>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/PaymentMethods/PaymentMethodDetail/components/General.tsx